import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'dateOfBirth.dayError'
  },
  {
    validate: (value) => /^(0?[1-9]|[1-2]\d|3[01])$/.test(value),
    errorMessage: 'dateOfBirth.dayError'
  }
];

export function useDayInputState(options) {
  return useInputState({
    initialValue: null,
    validations,
    ...(options || {})
  });
}
